import { SettingsSubscriptionsService } from "../client"

/* Endpoints */
export const readSubscriptionsSettings = () => {
  return {
    queryFn: async () => {
      const data = await SettingsSubscriptionsService.readSettingsSubscription()
      return data ?? { data: null, count: 0 }
    },
    queryKey: ["settings-subscriptions"],
  }
}
